import client from '../client';

const PATH = '/mapped-values';

/**
 * Get the mappedValues and notMappedValues of the given feature.
 * The returned object is documented in the API.
 * @param {Number} featureId the id of the feature to get its mapped and not mapped values.
 */
function get(featureId) {
  return client.get(PATH, { params: { featureId } }).then(({ data }) => data);
}

/**
 * Save a map between two values.
 * @param {Object} payload
 * @param {String} payload.value the value to map to the mapped one
 * @param {String} payload.mapped the value to save as the mapped one
 */
function save({ featureId, value, mapped }) {
  return client.post(PATH, { featureId, value, mapped })
}

/**
 * Remove an pair {featureId, value} from the database. This will remove the mapped item,
 * so the value must be mapped again.
 * @param {Object} payload
 * @param {Number} payload.featureId the id of the feature associated with the value
 * @param {String} payload.value the value to remove
 */
function remove({ featureId, value }) {
  return client.delete(PATH, { params: { featureId, value } })
}

export default {
  get,
  remove,
  save
}